export default __webpack_public_path__ + "static/media/lines-bg.c1099420.png";